import Service from '../pages/services';
import Footer from '../pages/footer';
import '../style/navs.css';
import SEO from '../Component/SEO';
export default function Pageservice() {
  return (
    <>
       <SEO
        title="Unsere Dienstleistungen - lamar-reinigung"
        description="Unsere Reinigungsdienste umfassen Industriereinigung, Büroreinigung, Fensterreinigung, Teppichreinigung und vieles mehr."
        keywords="Industriereinigung, Büroreinigung, Fensterreinigung, Teppichbodenreinigung, Hausmeisterdienst"
        url="https://lamar-f7165.web.app/service"
        image="https://lamar-reinigung.de/logo.png"
      />
      <div className='space'></div>
      <Service></Service>
      <Footer></Footer>
    </>
  );
}
